/**
 * 타이핑 인디케이터 — 봇이 응답 준비 중임을 표시
 */

import { cn } from '@/lib/utils';
import { Logo } from './Logo';

export function TypingIndicator() {
  return (
    <div className="ml-flex ml-gap-2 ml-animate-fade-in">
      <Logo size="sm" />
      <div
        className={cn(
          'ml-inline-flex ml-gap-1 ml-px-3.5 ml-py-2.5',
          'ml-bg-white ml-border ml-border-line',
          'ml-rounded-cb-md ml-rounded-bl-[4px]'
        )}
      >
        <Dot delay="0ms" />
        <Dot delay="150ms" />
        <Dot delay="300ms" />
      </div>
    </div>
  );
}

interface DotProps {
  delay: string;
}

function Dot({ delay }: DotProps) {
  return (
    <span
      className="ml-w-1.5 ml-h-1.5 ml-rounded-full ml-bg-mute ml-animate-bounce-dot"
      style={{ animationDelay: delay }}
    />
  );
}
